// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/BloqueiosAgenda_ListForAgendaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /bloqueios_agenda/list_for_agenda
 *
 * Validates requests to list schedule blocks within a datetime range.
 * Datetime fields must be in ISO 8601 UTC format.
 */
import { registerContract } from './validate'

export interface BloqueiosAgenda_ListForAgendaInput {
data_hora_inicio: string
data_hora_fim: string
}

registerContract('BloqueiosAgenda_ListForAgendaInput', {
  data_hora_inicio: { type: 'string',  required: true },
  data_hora_fim:    { type: 'string',  required: true },
})
